import React from 'react'
import { Col, Row } from 'reactstrap'
import PropTypes from 'prop-types'

const ProductPlaceholderCol = ({ index }) => (
  <Col
    key={ 'new-arrival-product-placeholder' }
    sm={ 3 }
    className='p-3'
  >
    <div
      className='bg-gray'
      style={{ width: 'auto', height: '140px' }}
    />
    { `Product ${index + 1}` }
  </Col>
)

ProductPlaceholderCol.propTypes = {
  index: PropTypes.number
}

const generateProducts = () => {
  const newArrivalCount = 8
  var products          = []
  for (var i = 0; i < newArrivalCount; i++) {
    products.push(i)
  }
  return products
}

const NewArrivalProductPlaceholder = () => (
  <Row>
    {
      generateProducts().map((index) => (
        <ProductPlaceholderCol
          key={ `product-placehodler-col-${index}` }
          index={ index }
        />
      ))
    }
  </Row>
)

export default NewArrivalProductPlaceholder